"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Snackbar = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _lab = require("@material-ui/lab");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    colorText: {
      color: theme.palette.text.primary
    },
    root: {
      marginTop: 24,
      marginRight: 24
    }
  };
});
/**
 * Componente primário de interação com o usuário
 */

var Snackbar = function Snackbar(_ref) {
  var children = _ref.children,
      severity = _ref.severity,
      show = _ref.show,
      handleClose = _ref.handleClose,
      classes = _ref.classes;
  var defaultClasses = useStyles();
  var cutomClasses = classes ? classes() : null;
  var snackbarStyle = cutomClasses ? cutomClasses.root : defaultClasses.root;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
    open: show,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    className: snackbarStyle
  }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    onClose: function onClose() {
      return handleClose && handleClose();
    },
    severity: severity
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: defaultClasses.colorText
  }, children))));
};

exports.Snackbar = Snackbar;
Snackbar.propTypes = {
  /**
   * Texto do Snackbar
   */
  children: _propTypes.default.string.isRequired,

  /**
   * Define a cor e o ícone do alerta
   */
  severity: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']).isRequired,

  /**
   * Se 'true' o Snackbar é exibido
   */
  show: _propTypes.default.bool.isRequired,

  /**
   * Função para fechar o snackbar
   */
  handleClose: _propTypes.default.func,

  /**
   * Função geradora de estilos. Deverá conter a chave `root`
   */
  classes: _propTypes.default.func
};
var _default = Snackbar;
exports.default = _default;
Snackbar.defaultProps = {
  handleClose: null,
  classes: null
};